import React from "react";


function HowToApply() {
    return(
        <div className="container-fluid">
         <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space50"></div>
                        <h2  className="aos-init aos-animate text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/legal251-how-to-apply.png" alt=""/>
                        <div className="space20"></div>
                     </div>
                  </div>
               </div>
     </div>
    );
}


export default HowToApply;